// third-party
import { FormattedMessage } from 'react-intl';

// assets
import SupportIcon from '@mui/icons-material/Support';

const supportTickets = {
    id: 'support-tickets',
    title: <FormattedMessage id="support-tickets" />,
    icon: SupportIcon,
    type: 'group',
    url: 'support-tickets',
    roles: ['admin', 'cs-technical', 'ca']
};

export default supportTickets;
